import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FixedAspectDirective } from './fixed-aspect.directive';
import { PhoneNumberPipe } from './phone-number.pipe';
import { SquareDirective } from './square.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        FixedAspectDirective,
        PhoneNumberPipe,
        SquareDirective
    ],
    exports: [
        FixedAspectDirective,
        PhoneNumberPipe,
        SquareDirective,
        CommonModule
    ],
    providers: []
})
export class SharedModule { }


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/shared.module.ts